import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";

export class FetchWindowsGruoupsResponse extends ServiceResponseData {
    groups: string[] = [];

    constructor(response: AxiosResponse) {
        super(response);
        if (response && response.data.Payload) {
            response.data.Payload.forEach((u) => {
                this.groups.push(u);
            });
        }
    }
}
